import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select,
} from '@mui/material';
import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getDataList } from '../../../helpers/getDataList';
import showMessage from '../../../helpers/showMessage';
import PageHeader from '../includes/PageHeader';
import EpgDetail from './EpgDetail';
import './epg.css';
import { ROUTES_LIST } from '../../../helpers/routesList';
import { LOCAL_STORAGE_USER, SESSION_NAME } from '../../../configs/constants';
export function Epg() {
    const [isLoading, setIsLoading] = useState(true);
    const [channelList, setChannelList] = useState([]);
    const [epgProgramId, setEpgProgramId] = useState('');
    const [selectedChannel, setSelectedChannel] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const [pageSize, setPageSize] = useState(100);
    const [epgStatus, setEpgStatus] = useState('waiting');
    const [error, setError] = useState(null);
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    useEffect(() => {
        let isActive = true;

        const logNetworkError = (error, context) => {
            const errorLog = {
                timestamp: new Date().toISOString(),
                context: context,
                status: error.response?.status,
                statusText: error.response?.statusText,
                errorMessage: error.response?.data?.message || error.message,
                errorData: error.response?.data,
                requestURL: error.config?.url,
                requestMethod: error.config?.method,
                userRole: user?.role,
            };
            console.error('🔴 Network Error Log:', errorLog);
            return errorLog;
        };

        const fetchData = async () => {
            try {
                const endpoint =
                    user?.role === 'OPERATOR'
                        ? `channel/${user?.channelId}`
                        : 'channel';
                console.log('📡 Fetching channels from:', endpoint);

                const response = await getDataList(endpoint);

                if (isActive) {
                    console.log('✅ Channels fetched successfully:', response);
                    const channels = response.data?.data;

                    setChannelList(channels || []);

                    if (channels && channels.length > 0) {
                        const defaultChannelId =
                            localStorage.getItem('channelId');
                        let selectedChannel;

                        if (defaultChannelId) {
                            selectedChannel = channels.find(
                                ({ id }) => id.toString() === defaultChannelId,
                            );
                        }

                        if (!selectedChannel) {
                            selectedChannel = channels[0];
                        }

                        setSelectedChannel(selectedChannel);

                        if (selectedChannel?.epgPrograms?.length > 0) {
                            setEpgProgramId(selectedChannel.epgPrograms[0]?.id);
                            setEpgStatus(
                                selectedChannel.epgPrograms[0]?.status,
                            );
                        } else {
                            setEpgProgramId(null);
                            setEpgStatus(null);
                        }
                    } else {
                        setSelectedChannel({});
                        setEpgProgramId(null);
                        setEpgStatus(null);
                    }

                    setIsLoading(false);
                }
            } catch (error) {
                logNetworkError(error, 'FETCH_CHANNELS');
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                console.error('❌ Failed to fetch channels:', message);
                setError(message);
                showMessage(message, enqueueSnackbar, 'error');
                setIsLoading(false);
            }
        };

        fetchData();

        return () => {
            isActive = false;
        };
    }, [enqueueSnackbar, user?.role, user?.channelId]);

    if (isLoading)
        return (
            <Box sx={{ width: '100%', padding: '20px' }}>
                <LinearProgress />
            </Box>
        );

    const handleInputChange = (e) => {
        const { value } = e.target;

        setEpgProgramId(value);
        const status = '';
        selectedChannel.epgPrograms.map((epgProgram) => {
            if (epgProgram.id === value) {
                status = epgProgram.status;
            }
        });
        setEpgStatus(status);
    };

    const changeChannel = (channelId) => {
        const selectedChannel = channelList.find(({ id }) => id === channelId);
        if (selectedChannel) {
            setEpgProgramId(selectedChannel?.epgPrograms[0]?.id);
            setEpgStatus(selectedChannel?.epgPrograms[0]?.status);
            setSelectedChannel(selectedChannel);
            localStorage.setItem('channelId', channelId);
        } else {
            setEpgProgramId();
            setSelectedChannel({});
        }
    };
    const localizedTextsMap = {
        columnMenuUnsort: 'Ангилаагүй',
        columnMenuSortAsc: 'Өсөхөөр эрэмблэх',
        columnMenuSortDesc: 'Буурахаар эрэмблэх',
        columnMenuFilter: 'Хайх',
        columnMenuHideColumn: 'Нуух',
        columnMenuShowColumns: 'Багана харах',
    };

    const channelColumns = [
        {
            field: 'name',
            headerName: 'Нэр',
            renderCell: (params) => {
                return <Box style={{ cursor: 'pointer' }}>{params.value}</Box>;
            },
            flex: 1,
        },
    ];
    return (
        <div className="epg-wrapper">
            <div className="epg-channel">
                <Grid
                    container
                    justifyContent="center"
                    style={{ height: 630, width: '100%' }}
                >
                    <PageHeader pageName="ТВ суваг" showAddNew={false} />
                    {isLoading ? (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    ) : error ? (
                        <Box
                            sx={{
                                width: '100%',
                                padding: '20px',
                                textAlign: 'center',
                                color: 'red',
                            }}
                        >
                            <p>❌ Алдаа: {error}</p>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => window.location.reload()}
                            >
                                Дахин ачааллах
                            </Button>
                        </Box>
                    ) : (
                        <DataGrid
                            rows={channelList || []}
                            columns={channelColumns}
                            pageSize={pageSize}
                            onPageSizeChange={(newPage) => setPageSize(newPage)}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                            pagination
                            checkboxSelection={false}
                            disableSelectionOnClick
                            onCellClick={(params) => changeChannel(params.id)}
                            localeText={localizedTextsMap}
                        />
                    )}
                </Grid>
            </div>
            <div className="epg-detail">
                <PageHeader
                    pageName={selectedChannel.name + `-н хөтөлбөр`}
                    showAddNew={false}
                />
                <Box sx={{ minWidth: 120 }}>
                    <FormControl className="epg-detail-week-form">
                        <InputLabel id="epg-detail-week">
                            Долоо хоног
                        </InputLabel>
                        <Select
                            labelId="epg-detail-week"
                            id="epg-detail-week-id"
                            value={epgProgramId}
                            label="Долоо хоног"
                            onChange={handleInputChange}
                        >
                            {selectedChannel.epgPrograms &&
                                selectedChannel.epgPrograms.map(
                                    (epgProgram) => (
                                        <MenuItem
                                            key={epgProgram.id}
                                            value={epgProgram.id}
                                        >
                                            {epgProgram.broadcastWeek}
                                        </MenuItem>
                                    ),
                                )}
                        </Select>
                    </FormControl>
                    <Link
                        to={`${ROUTES_LIST.dashboard}/program/create/${selectedChannel.id}`}
                    >
                        <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            className="create-btn"
                            style={{ backgroundColor: 'forestgreen' }}
                        >
                            Хөтөлбөр файлаар нэмэх
                        </Button>
                    </Link>
                </Box>
                {epgProgramId &&
                    (epgStatus === 'approved' ? (
                        <EpgDetail
                            epgProgramId={epgProgramId}
                            isEdit={true}
                        ></EpgDetail>
                    ) : (
                        <Grid
                            container
                            justifyContent="center"
                            style={{ marginTop: '30px' }}
                        >
                            Хөтөлбөр батлагдаагүй байна.
                        </Grid>
                    ))}
            </div>
        </div>
    );
}
